
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/scrollo/js/scrollo';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/auto-hide-bar/js/auto-hide-bar';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/stickyElements/js/stickyElements';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/plugins/sticko/js/sticko';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/coolbar/js/coolbar';
  
import GoToSection from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/go-to-section/js/goToSection';  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/coolbar/js/setStickeyTop';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/ad-placeholder/js/ad-placeholder';
  
const main = (UX) => {
    const $scrollo = Array.prototype.slice.call(document.querySelectorAll('.table-fn, .ref.fn, .scroll-to-target')),
        $autoHideBar = Array.prototype.slice.call(document.getElementsByClassName('auto-hide-primary-bar')),
        $sticko = Array.prototype.slice.call(document.getElementsByClassName('sticko')),
        $coolbar = Array.prototype.slice.call(document.getElementsByClassName('coolBar')),
        $goToSection = Array.prototype.slice.call(document.querySelectorAll('.table-fn, .ref.fn, .scroll-to-target, a.sr-only-focusable, .article__content, [data-db-target-of=sections] a, .scrollableLink, .scrollableLinks a, .comment-link a, .PdfLink a[href="#accessDenialLayout"], .article-section__full a[href*="#"]')),
        $setStickeyTop = Array.prototype.slice.call(document.getElementsByClassName('stickybar')),
        $adplaceholder = Array.prototype.slice.call(document.getElementsByClassName('js__toggleAdForm'))

try {
        if ($scrollo.length ) {
            UX.scrollo.init($scrollo);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($autoHideBar.length ) {
            UX.autoHideBar.init($autoHideBar);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.stickyElements.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($sticko.length ) {
            UX.sticko.init($sticko);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($coolbar.length ) {
            UX.coolbar.init($coolbar);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($goToSection.length ) {
            UX.goToSection = new GoToSection($goToSection).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($setStickeyTop.length ) {
            UX.setStickeyTop.init($setStickeyTop);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($adplaceholder.length ) {
            UX.adplaceholder.init($adplaceholder);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        